export default __webpack_public_path__ + "static/media/Jay.e4db404c.jpg";